import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  modalRef: BsModalRef;
  confirmResponse: Subscription;

  constructor(
    private auth: AuthService,
    private modalService: BsModalService,
    private router: Router
  ) { }

  get isLoggedIn() {
    return this.auth.isLoggedIn;
  }

  get client() {
    return this.auth.client;
  }

  ngOnInit() {
  }

  onLogout() {
    this.modalRef = this.modalService.show(ConfirmDialogComponent,
      {
        initialState:
        {
          title: 'Logout?',
          message: 'Are you sure you want to log out?'
        }
      });
    
      this.confirmResponse = this.modalService.onHide.subscribe(result => {
        this.confirmResponse.unsubscribe();
  
        if (result == 'confirm') {
          this.auth.logout();
          this.router.navigate(['/login']);
        }
  
      });
  }

}
